import { forwardRef } from "react"
import { DatePicker as IDatePicker } from "../DatePicker"

export type DatePickerProps = React.ComponentPropsWithRef<typeof IDatePicker>

const DatePicker: React.FC<DatePickerProps> = forwardRef((props, forwardedRef) => (
  <IDatePicker ref={forwardedRef} {...props} />
))

DatePicker.displayName = `InputGroup.DatePicker`

export { DatePicker }
